module.exports = __webpack_public_path__ + "img/5.6286b0e4.png";